
function AnimationTitle(){

    this.build();

}

AnimationTitle.prototype.build = function(){

    $('.main-title-home > span').each(function(){
        let element = $(this);
        let trigger = $('.main-title-home');

        gsap.to(element, {
            x: 0,
            ease: 'none',
            scrollTrigger: {
                trigger: trigger,
                start: 'top top+=200',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    $('.master-title').each(function(){
        let element = $(this);
        let trigger = element.closest('div');

        if( element.data('direction') === "horizontal" ) {

            gsap.to(element, {
                x: '-50%',
                ease: 'none',
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top center',
                    end: window.innerWidth * 5,
                    scrub: true
                }
            });

        }

        if( element.data('direction') === "vertical" ) {

            gsap.to(element, {
                y: '-50%',
                ease: 'none',
                scrollTrigger: {
                    trigger: '.page-inner',
                    start: 'top top',
                    end: window.innerHeight * 3,
                    scrub: true
                }
            });

        }

    });

};
